<template>
     <div class="column" @click.prevent="changeSource(video)">
        <div class="thumbnail">
            <span  class="thumbnail-top thumbnail-time" :title="video.duration"> {{video.duration}} </span>
            <span  class="thumbnail-top thumbnail-date" :title="video.date"> {{video.date}} </span>
            <img  class="thumbnail-image" :src="video.imgSrc"/>
            <span class="video-title">{{video.title}}</span>
            <div class="tumbnail-overlay"></div>
        </div>
         <div class="information" v-if="informations">
            <ul>
                <li v-if="video.attribution">
                    <span class="attribution">{{video.attribution}}</span>
                </li>
                <li v-if="convertViews">
                    <span class="view-count" > {{convertViews}} vues</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faPlayCircle } from '@fortawesome/free-solid-svg-icons'
    import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
    Vue.component('font-awesome-icon', FontAwesomeIcon);
    library.add(faPlayCircle)
export default {
    props:{
        video:{},
        currentVideo: {
        type : Function
    },
    },
    informations:{
        type:Boolean,
        default:false
    },
    methods:{
        changeSource(video) {
            this.currentVideo(video);
        }
    },
    computed:{
        convertViews(){
            var digits=1;
            var si = [
                { value: 1, symbol: "" },
                { value: 1E3, symbol: " k" },
                { value: 1E6, symbol: " M" },
                { value: 1E9, symbol: " G" },
                { value: 1E12, symbol: " T" },
                { value: 1E15, symbol: " P" },
                { value: 1E18, symbol: " E" }
            ];
            var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
            var i;
            for (i = si.length - 1; i > 0; i--) {
                if (parseInt(this.video.vueNbr) >= si[i].value) {
                break;
                }
            }
            return (parseInt(this.video.vueNbr) / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
        }
    }
}
</script>

<style scoped>
    video-horizontal{
        font-family: Arial, sans-serif;
    }
   .column {
        position: relative;
        min-width: var(--video-horizontal-column-width,15%);
        margin: var(--video-horizontal-column-margin,2px);
        height: var(--video-horizontal-column-height,calc(var(--video-horizontal-column-width)*9/16));
    }
    .thumbnail{
        height: calc(var(--video-horizontal-column-width)*9/16);
        width: var(--video-horizontal-column-width,15%);
        position:relative;
        cursor:pointer;
    }
    .thumbnail-image {
        min-width: var(--video-horizontal-column-width,15%);
        height: calc(var(--video-horizontal-column-width)*9/16);
    }
    .tumbnail-overlay{
        min-width: var(--video-horizontal-column-width,15%);
        height: var(--video-horizontal-column-height,calc(var(--video-horizontal-column-width)*9/16));
        position: absolute;
        top: 0; 
        left: 0;
        right: 0;
        bottom: 0;
        display: var(--video-horizontal-display,block);
        background-color:  var(--video-horizontal-bg-color,rgba(12,82,155,0.5));
        z-index: 1;
    }
    .video-title{
        color:var(--video-vertical-title-color,#fff);
        font-size: 1.15rem;
        font-weight: 500;
        font-family: Arial, sans-serif;
        position: absolute;
        z-index: 2;
        bottom: 0;
        width: 100%;
        left: 0;
        text-align: center;
        font-weight: 600;
        padding: 0 0 1rem 0;
    }
    .play-icon{
        color: var(--video-play-icon-color,#fff);
        left: var(--video-horizontal-play-icon-position-left,6rem);
        top: var(--video-horizontal-play-icon-position-left,3.2rem);
        height: var(--video-horizontal-play-icon-height,4.2rem);
        opacity: 0;
        transition: all .5s ease-in-out;
        cursor: pointer;
    }
    .thumbnail-date{
        left: 6px;
        width: 4rem;
    }
    .thumbnail-top{
        top: var(--video-horizontal-time-top,0.4rem);
        font-size: var(--video-horizontal-time-font-size,.8rem);
        font-weight: var(--video-horizontal-time-font-weight,500);
        background-color: var(--video-horizontal-time-bg-color,#111);
        color: var(--video-horizontal-time-bg-text-color,#fff);
        opacity: 0;
        position: absolute;
        border-radius: var(--video-horizontal-time-border-radius,2px);
        z-index: 2;
        transition: all .5s ease-in-out;
        padding: var(--video-horizontal-time-text-padding,3px);
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
        supported by Chrome and Opera */
    }
   .thumbnail-time{
        right: var(--video-horizontal-time-right,.3rem);
    }
    .column:hover .thumbnail-time {
        opacity: var(--video-horizontal-title-bg-opacity,.8)
    }
    .column:hover .thumbnail-date {
        opacity: var(--video-horizontal-title-bg-opacity,.8)
    }
    .column:hover .play-icon{
        opacity: var(--video-play-icon-opacity,1);
    }
    .attribution {
        font-weight: var(--video-vertical-attribution-font-weight,500);
        font-size: var(--video-vertical-attribution-font-size,0.8rem);
        color: var(--video-vertical-attribution-text-color,#554E4E)!important;
    }
    .view-count{
        font-weight: var(--video-vertical-information-font-weight,500);
        font-size: var(--video-vertical-information-font-size,0.8rem);
        color: var(--video-vertical-information-text-color,#5f5757)!important;
    }
    .information{
        margin : auto 0;
    }
    .information > ul{
        list-style-type: none;
        margin: 10px;
        padding: 0;
    }
</style>




// WEBPACK FOOTER //
// node_modules/component-video/src/components/VideoHorizontal.vue